// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Email';

export function Email() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label={TITLE}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        d="M2 17.2612V6.73878L7.975 12.1755L2 17.2612ZM22 19H2L8.99167 13.0571L12 15.8082L15.0083 13.0571L22 19ZM12 14.0122L2.05833 5H21.9417L12 14.0122ZM22 6.73878V17.2612L16.025 12.1755L22 6.73878Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EmailSimple() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        d="M2 20V4h20v16H2Zm10-7 8-5V6l-8 5-8-5v2l8 5Z"
        fill="currentColor"
      />
    </svg>
  );
}
